module.exports = __webpack_public_path__ + "media/images/barco-5705d8c317fd13b9cc1c66d707a26579.png";